function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import Container from "../Container";
import { Close } from "../Icon";
import Link from "../Link";
import BackgroundProvider from "../BackgroundProvider";
import SafeSecureText from "./SafeSecureText";
import { StyledHeaderSecureInformation, StyledHeaderSecureInformationContainer } from "./styled";
var TRANSITION_DELAY = 100;
var TRANSITION_LENGTH = 400;
var SafeSecureInformation = function SafeSecureInformation(_ref) {
  var onSafeSecureClick = _ref.onSafeSecureClick,
    open = _ref.open,
    safeSecureText = _ref.safeSecureText,
    width = _ref.width;
  var _useState = useState({
      height: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dimensions = _useState2[0],
    setDimensions = _useState2[1];
  var heightAutoTimeout = useRef();
  var heightZeroTimeout = useRef();
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isReadyToAnimate = _useState4[0],
    setIsReadyToAnimate = _useState4[1];
  var targetRef = useRef(null);
  var theme = useTheme() || {};
  var transitionEnd = useCallback(function () {
    if (targetRef.current && targetRef.current.offsetHeight === 0) {
      targetRef.current.style.visibility = 'hidden';
    }
  }, []);
  useEffect(function () {
    if (targetRef.current) {
      transitionEnd();
      targetRef.current.addEventListener('transitionend', transitionEnd);
    }
    return function () {
      return targetRef.current && targetRef.current.removeEventListener('transitionend', transitionEnd);
    };
  }, []);
  useEffect(function () {
    if (heightAutoTimeout.current) clearTimeout(heightAutoTimeout.current);
    if (heightZeroTimeout.current) clearTimeout(heightZeroTimeout.current);

    /**
     * Ensure there are no tabbable elements when the Safe and Secure information
     * text is hidden.
     */
    if (!open && targetRef.current) {
      var clickableChildren = targetRef.current.querySelectorAll('a, button, [tabindex="0"]');
      clickableChildren.forEach(function (child) {
        child.setAttribute('tabindex', '-1');
        child.setAttribute('disabled', '');
      });
    }

    /**
     * Ensure tabbable elements are made tabbable when the Safe and Secure
     * information becomes visible.
     */
    if (open && targetRef.current) {
      var _clickableChildren = targetRef.current.querySelectorAll('a, button, [tabindex="-1"]');
      _clickableChildren.forEach(function (child) {
        child.setAttribute('tabindex', '0');
        child.removeAttribute('disabled');
      });
    }

    /**
     * Animate
     */
    if (open && isReadyToAnimate && targetRef.current) {
      targetRef.current.style.visibility = 'visible';
      /* Calculate height of secure text section */
      setDimensions({
        height: targetRef.current.scrollHeight
      });

      /* Wait for CSS transition to finish, then set height to 'auto' */
      heightAutoTimeout.current = setTimeout(function () {
        if (targetRef.current) targetRef.current.style.height = '';
        setIsReadyToAnimate(false);
      }, TRANSITION_LENGTH + TRANSITION_DELAY);
    }
    if (!open && !isReadyToAnimate && targetRef.current && targetRef.current.scrollHeight) {
      /* Replace height:auto with the correct height */
      targetRef.current.style.height = "".concat(targetRef.current.offsetHeight, "px");

      /* After a short delay, allow height to be set to 0. This will kickstart the CSS transition */
      heightZeroTimeout.current = setTimeout(function () {
        setIsReadyToAnimate(true);
      }, TRANSITION_DELAY);
    }
  }, [open]);

  /* Change height of secure text section to either 0 (after delay) or the correct height */
  var containerStyle = isReadyToAnimate ? {
    height: open ? dimensions.height : 0,
    overflow: 'hidden'
  } : {};
  return /*#__PURE__*/React.createElement(StyledHeaderSecureInformationContainer, {
    "aria-hidden": !open,
    className: "csl-header__secure-information-container",
    ref: targetRef,
    style: containerStyle
  }, /*#__PURE__*/React.createElement(Container, {
    width: width
  }, /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.header_color_secure_information_background
    }
  }, /*#__PURE__*/React.createElement(StyledHeaderSecureInformation, {
    className: "csl-header__secure-information"
  }, /*#__PURE__*/React.createElement(Link, {
    disabled: !open,
    className: "csl-header__secure-information-close",
    icon: /*#__PURE__*/React.createElement(Close, {
      size: "s1",
      trim: true
    }),
    iconPosition: "left",
    onClick: onSafeSecureClick,
    size: "s1",
    title: "Click or press enter to hide the content",
    underline: false
  }, "Close"), typeof safeSecureText === 'boolean' ? /*#__PURE__*/React.createElement(SafeSecureText, null) : safeSecureText))));
};
export default SafeSecureInformation;